const translations = {
    es: {
        "tpmc-prepare": "Preparando...",
        "duplicate-suffix": "(copia)",
        "duplicate-ok-title": "Duplicada",
        "duplicate-ok-text": "Se ha duplicado la ruta",
        "duplicate-error": "No se ha podido duplicar la ruta",
        "optimize-route": "Optimizar Ruta",
        "optimize-one-route": "Sin optimizar hay que elegir una sola Ruta Estática",
        "route-order": "Orden",
    },
    en: {
        "tpmc-prepare": "Prepare...",
        "duplicate-suffix": "(copy)",
        "duplicate-ok-title": "Duplicated",
        "duplicate-ok-text": "The route has been duplicated",
        "duplicate-error": "The route could not be duplicated",
        "optimize-route": "Optimize route",
        "optimize-one-route": "Without optimizing, you must choose a single Static Route",
        "route-order": "Order",
    }
};

export default translations;